export default __webpack_public_path__ + "static/media/minus.5d6dfab1.svg";